import get from 'lodash/get';

import FormulasService from '../common/RichTextBox/FormulaChip/formulas-service';
import {
	INSERT_DATA_DELIMITER_PREFIX as PREFIX,
	INSERT_DATA_DELIMITER_SUFFIX as SUFFIX,
} from '@/components/common/RichTextBox/DataChip/data-chip.const';
import FormatConversionService from '@/components/common/RichTextBox/format-conversion-service';
import ParsingService from '@/components/common/RichTextBox/parsing-service';
import ParamsService from '@/utils/ParamsService';
import { TEST_RESULT_STATUSES } from '@/utils/workflow-node.const';

export const VALID_TO_PUBLISH_STATUSES = [TEST_RESULT_STATUSES.SUCCESS, TEST_RESULT_STATUSES.SKIPPED];

const isString = (input) => typeof input === 'string';

const processPreviousSteps = (
	value,
	previousSteps,
	replaceInsertDataStringDict = {},
	configurationsMappingBlocksUUIDs = [],
	isReceivesHtml = false
) => {
	try {
		const valueObject = { value };
		while (isString(valueObject.value) && FormulasService.hasFormula(valueObject.value)) {
			valueObject.value = FormulasService.runNoneUIFormulas(valueObject.value, previousSteps, replaceInsertDataStringDict);
		}
		const interpolatedData = ParsingService.mapAllDelimited(PREFIX, SUFFIX, valueObject.value, (delimitedString) => {
			const wrappedDelimitedString = `${PREFIX}${delimitedString}${SUFFIX}`; // so it works with regex
			const path = ParamsService.extractPathFromValue(wrappedDelimitedString);
			const processedKey = ParamsService.extractPathFromValue(
				wrappedDelimitedString,
				replaceInsertDataStringDict,
				configurationsMappingBlocksUUIDs
			);

			if (processedKey) {
				delimitedString = delimitedString.replace(path, processedKey);
			}

			const previousStepVal = get(previousSteps, delimitedString, '');
			if (isReceivesHtml) {
				return previousStepVal;

				// Guy, this removed as convertToHtmlForTiptapPresentation is falsely thinks HTML is markdown

				// const result = FormatConversionService.convertToHtmlForTiptapPresentation(previousStepVal);
				// return ParsingService.removeEnclosingParagraphTags(result);
			} else {
				return FormatConversionService.convertMarkdownToTextForTiptapPresentation(previousStepVal);
			}
		});

		valueObject.value = interpolatedData;

		return valueObject.value;
	} catch (err) {
		console.error(err);
		return value || '';
	}
};

const isFileViewerActive = (widgetOptions) => ((widgetOptions || {}).file_viewer || {}).active;

const isIframeSubmitDisabled = (widgetOptions) => ((widgetOptions || {}).iframeSubmitDisabled || {}).active;

const WidgetFormService = {
	processPreviousSteps,
	isFileViewerActive,
	isIframeSubmitDisabled,
};

export default WidgetFormService;
